/**
 *
 * ResultsItem
 *
 */

import React, { memo, FunctionComponent } from 'react';
import helmetIcon from '../../../../assets/icons/helmet.svg';
import horseIcon from '../../../../assets/icons/horse.svg';
import { EventType, LiveFeedEventResult } from '../../../../domain';

interface IProps {
  result: LiveFeedEventResult;
  type?: EventType;
  disabledFields: string[];
}

const ResultsItem: FunctionComponent<IProps> = ({ result, disabledFields }) => {
  const isEnabled = (field: string) => {
    return !disabledFields.includes(field);
  };

  return (
    <tr>
      <td>{isEnabled('eaEventClassAndSort') && result.eaEventClassAndSort}</td>
      <td>{isEnabled('sectionName') && result.sectionName}</td>
      <td>
        {isEnabled('bridleNumber') && (
          <div className="fw-7">{result.bridleNumber}</div>
        )}
      </td>
      <td>
        <div className="d-flex align-items-center">
          <img src={helmetIcon} className="mr-11" alt="" />
          <div className="fs-12 fw-7 text-nowrap">
            {result.riderFirstName} {result.riderLastName}
          </div>
        </div>
        <div className="fs-12">{result.horseName}</div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <img src={horseIcon} className="mr-11" alt="" />
          <div className="d-flex flex-column">
            <div className="fs-12 fw-7 text-nowrap">{result.horseName}</div>
            <div className="fs-12 txt-secondary">
              Owner: {result.ownerFirstName} {result.ownerLastName}
            </div>
          </div>
        </div>
      </td>
      <td>
        {isEnabled('selectedResult') && (
          <div className="fw-7">{result.selectedResult}</div>
        )}
      </td>
      <td>
        {isEnabled('riderClassStatusCode') && (
          <div className="fw-7 fs-12">{result.riderClassStatusCode}</div>
        )}
      </td>
    </tr>
  );
};

export default memo(ResultsItem);
